import React, { useEffect, useState } from 'react';
import UserFrom from './UsersForm';
import ArtisanForm from './ArtisanForm';
import ApplicantForm from './ApplicantForm';
import CustomerForm from './CustomerForm';
import SuppliersForm from './SupplierForm';
import {
  currentUserSelector,
  userByIdSelector,
} from '../../../modules/users/Selectors';
import { getUserAction } from '../../../modules/users/Actions';
import { connect } from 'react-redux';
import ShowAllButton from '../../../components/form/ShowAllButton';
import { Redirect, withRouter } from 'react-router-dom';
import { object } from 'prop-types';
import TrainingCenterFrom from './TrainingCenterFrom';

// import ApplicantForm from './ApplicantForm';

const FormIndex = (props) => {
  const { userId, getUser, user, currentUser } = props;

  useEffect(() => {
    if (userId) {
      getUser(userId);
    }
    // console.log(props.match.params.id)
  }, []);

  // const { profiles, ...userData } = currentUser;
  // const artisanData = currentUser.profiles?.artisan;
  // const supplierData = currentUser.profiles?.supplier;
  // const customerData = currentUser.profiles?.customer;
  // const applicantData = currentUser.profiles?.applicant;
  // const {artisan, supplier, customer, applicant} = profiles
  // user && console.log('user', artisanData);
  // const userId = props.match.params.id
  const [page, setPage] = useState(['0']);
  console.log(page, 'page');
  const renderItems = () => {
    if (page.indexOf('0') !== -1)
      return <UserFrom setPage={setPage} page={page} />;
    else if (page.indexOf('3') !== -1)
      return <ArtisanForm setPage={setPage} page={page} />;
    else if (page.indexOf('4') !== -1)
      return <CustomerForm setPage={setPage} page={page} />;
    else if (page.indexOf('5') !== -1)
      return <SuppliersForm setPage={setPage} page={page} />;
    else if (page.indexOf('6') !== -1)
      return <ApplicantForm setPage={setPage} page={page} />;
    else if (page.indexOf('8') !== -1) 
      return <TrainingCenterFrom setPage={setPage} page={page} />
    // return <div>applicant From</div>;
    else return <Redirect to="/users" />;
  };

  // const editForms = () => {
  //   return (
  //     <>
  //       <UserFrom setPage={setPage} page={page} userData={userData} />
  //       <ArtisanForm setPage={setPage} page={page} artisanData={artisanData} />
  //       {/* <div>Artisan Form</div> */}
  //       <CustomerForm
  //         setPage={setPage}
  //         page={page}
  //         customerData={customerData}

  //       />
  //       <SuppliersForm
  //         setPage={setPage}
  //         page={page}
  //         supplierData={supplierData}
  //       />
  //       <ApplicantForm
  //         setPage={setPage}
  //         page={page}
  //         applicantData={applicantData}
  //       />
  //     </>
  //   );
  // };

  return <> {renderItems()}</>;
  // return <>
  // <UserFrom></UserFrom>
  // <ShowAllButton></ShowAllButton>
  // </>;
};

const mapStateToProps = (state, props) => {
  const userId = props.match.params.id;
  return {
    userId,
    user: userByIdSelector(state, userId),
    currentUser: currentUserSelector(state),
  };
};

const mapDispatchToProps = {
  getUser: getUserAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(FormIndex);
